import type { FaireProductEntity } from "../../entity_types/product";

export const p_eqa5jvu3cn: FaireProductEntity = {
  token: "p_eqa5jvu3cn",
  type: "product",
  name: "Trophy Wife Gym Crew Socks - Bachelorette Gift",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/6e0e4b1044df9efc3c4d259a52468335d72117340520503069b0f982df6fa447.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4e2cabf8794c922df1e3096a8f3091f1f9e402a1fe6566842ab5f8918f13642a.jpeg",
    "https://cdn.faire.com/fastly/3cd40d895d863050bc1070c9b9ab629d428327ea0538b9b39d897ab70d33008e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/7f103f2a82970b25375b3e16f7c2275d59176e3512c8601b1870f47187a782e8.jpeg",
    "https://cdn.faire.com/fastly/2fab81d4121ae4da71e7319fdd5bb03c6f568a4f4fb097ffe3311c3173e32055.jpeg"
  ],
  priceDollars: 6.75,
  description: "When you look good standing next to anyone, you know you're a prize. Treat yourself to these socks, you sexy thing, you.\n\nA fun and flirty gift for bachelorettes, brides, anniversaries, or Valentine’s Day—these funny socks are made for anyone who knows they’re a total prize. Ideal for wedding party gifts or cheeky Mother's Day moments.\n\nKey features of our Trophy Wife gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:26.574Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
